import { IColumn } from '../../../store/modules/report/i-column';

/**
 * Filters out report headers whose column definition is marked hidden (AVP-713).
 * A header is dropped when a column with a matching `header` (or `field`) has a
 * truthy `hidden` flag. Headers with no matching column are kept as-is.
 */
const filterHiddenHeaders = (headers: string[], columns?: IColumn[]): string[] => {
  if (!columns || !columns.length) {
    return headers;
  }

  const hidden = new Set<string>();
  columns.forEach((column) => {
    if (column.hidden) {
      if (column.header) hidden.add(column.header);
      if (column.field) hidden.add(column.field);
    }
  });

  return headers.filter((header) => !hidden.has(header));
};

export default filterHiddenHeaders;
